import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";
import { getUserDetails } from "../utils/userDetailsUtils";

const fetchAttributes = async (testStepId) => {
  const user = getUserDetails();

  const params = new URLSearchParams({
    action: "getAttributes",
    companyId: user.companyid,
    testStepId,
  });

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?${params.toString()}`,
  );

  return response.data;
};

const useGetAttributesQuery = (testStepId, options = {}) => {
  return useQuery({
    queryKey: ["getAttributes", testStepId],
    queryFn: () => fetchAttributes(testStepId),
    enabled: options.enabled !== undefined ? options.enabled : !!testStepId,
    retry: false,
    refetchOnWindowFocus: false,
  });
};

export default useGetAttributesQuery;
